<template>
	<div>
		<div class="tab-base">
			<el-tabs v-model="tabs" @tab-click="handleClick">
				<el-tab-pane v-for="item in tabList" :label="item.name" :name="item.id" :key="item.id"></el-tab-pane>
			</el-tabs>

			<el-input v-model="value" :placeholder="$t('请输入搜索的内容')" size="medium" prefix-icon="el-icon-search" clearable
				style="width: 220px;" @change="valueChange"></el-input>
		</div>
		<div class="table-div">
			<div class="th-div dis-fle">
				<div class="flex-1" style="justify-content: flex-start;">
					<span>{{ $t('币种') }}</span>
				</div>
				<div class="flex-1">
					<span>{{ $t('收盘价') }}</span>
				</div>
				<div class="flex-1">
					<span>{{ $t('24H 改变') }}</span>
				</div>
				<div class="flex-1">
					<span>{{ $t('高') }}</span>
				</div>
				<div class="flex-1 telHide">
					<span>{{ $t('低') }}</span>
				</div>
				<div class="flex-1 telHide">
					<span>{{ $t('交易额') }}</span>
				</div>
				<div class="flex-1">
					<span>{{ $t('市场交易') }}</span>
				</div>
			</div>
			<div class="tr-div">
				<div class="tr dis-fle" v-for="item in tableData" :key="item.id">
					<p class="td-img" style="justify-content: flex-start;">
						<i class="el-icon-star-on cur-poi" :style="{ color: item.selected == 1 ? '#f0c163' : '' }"
							@click="recentOrder(item)"></i>
						<img :src="item.image" />
						<span>{{ item.title }}</span>
					</p>
					<p>
						<span class="m22">${{ item.price }}</span>
					</p>
					<p :class="[item.price_zf >= 0 ? 'green' : 'red']">
						<span>{{ item.price_zf >= 0 ? '+' : '' }}{{ item.price_zf }}%</span>
					</p>
					<p>
						<span>${{ item.price_high }}</span>
					</p>
					<p>
						<span>${{ item.price_low }}</span>
					</p>
					<p>
						<span>{{ item.vol }}</span>
					</p>
					<p>
						<span class="but" @click="$nav.go('/pc/trade?code=' + item.code)">{{ $t('交易') }}</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { get, post } from '@/http/request'
export default {
	components: {},
	data() {
		return {
			tabs: '0',
			tabList: [],
			value: '',
			tableData: [],
		};
	},
	created() {
		get(this.$apis.getProductTypeList, { showLoading: false }).then(res => {
			if (res.code != 1) return
			this.tabList = res.data.map(item => {
				item.id = String(item.id)
				return item
			}) || []

			if (this.tabList.length > 0) {
				this.tabs = this.tabList[0].id
				this.getData()
			}
		})
	},
	methods: {
		handleClick() {
			// console.log(val) 
			this.getData()
		},
		valueChange() {
			// console.log(val)
			this.getData()
		},
		getData() {
			get(this.$apis.getProductList, { type: this.tabs, title: this.value }).then(res => {
				if (res.code != 1) return
				this.tableData = res.data
			})
		},
		recentOrder(item) {
			post(this.$apis.operateUserProduct,
				{
					product_ids: item.id,
					type: item.selected == 0 ? 1 : 2
				}).then(res => {
					if (res.code == 1) {
						this.getData()
					}
				})
		},
	},
};
</script>
<style lang="scss" scoped>
.table-div {
	margin-top: 20px;

	.tr-div {
		.tr {
			padding: 25px;
			border-bottom: 1px solid #222b39;

			p {
				flex: 1;
				font-size: 15px;
				font-weight: 700;
				display: flex;
				justify-content: center;
				align-items: center;

				&.td-img {
					i {
						font-size: 18px;
					}

					img {
						width: 24px;
						height: 24px;
						object-fit: cover;
						border-radius: 50%;
						margin: 0px 5px;
					}
				}

				.but {
					border: 1px solid #fff;
					padding: 4px 30px;
					border-radius: 30px;
					cursor: pointer;
				}
			}

			.red {
				color: #ff4834 !important;
			}

			.green {
				color: #00f0ff !important;
			}
		}
	}

	.th-div {
		background: #1c222c;
		padding: 13px 25px;

		>div {
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

}

.tab-base {
	margin-top: 42px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>